module.exports = __webpack_public_path__ + "img/Invasion-BRME_GSE179572.5bc631c0.png";